import { TabletOutlined, WhatsAppOutlined } from '@ant-design/icons'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { ConditionalLinkWrapper } from '@supplement-bacon/react-toolkit/utils'
import { Space, Tag } from 'antd'
import { Venue as VenueModel } from '../../models/Venue'
import { useTenant } from '../../modules/tenant/contexts/tenant/TenantContext'
import { useAppSelector } from '../../store/hooks'
import { selectVenueById } from '../../store/VenueReducer'

type Props = SBModelComponent<VenueModel> & {
  linkToDetail?: boolean
}

export const VisibilityOverview = ({
  id,
  model,
  linkToDetail = false,
}: Props) => {
  const { allPlatforms } = useTenant()
  const venue = model ? model : useAppSelector(selectVenueById(id!))

  if (!venue) {
    return <></>
  }

  const getColorForVisibility = (visibility: string) => {
    switch (visibility) {
      case 'visible':
        return 'green'
      case 'hidden':
        return 'orange'
      case 'temporarilyClosed':
        return 'red'
    }
  }

  return (
    <ConditionalLinkWrapper
      to={`/venues/${venue.slug}/generals`}
      condition={linkToDetail}
      onClick={undefined}
      wrapper={(children) => children}
    >
      <Space wrap>
        <Tag
          icon={<TabletOutlined />}
          color={getColorForVisibility(venue.visibility.application)}
        >
          {allPlatforms.ios.name} & {allPlatforms.android.name}
        </Tag>
        <Tag
          color={getColorForVisibility(venue.visibility.whatsapp)}
          icon={<WhatsAppOutlined />}
        >
          {allPlatforms.whatsapp.name}
        </Tag>
      </Space>
    </ConditionalLinkWrapper>
  )
}

export type VisibilityOverviewType = {
  VisibilityOverview: typeof VisibilityOverview
}
